export default __webpack_public_path__ + "static/media/location_grey.fe202e0f.svg";